<template>
	<div class="about">
		<!-- <div class="content-box" :class="{ 'content-collapse': collapse }" style="border-left:10px solid #f0f0f0;border-top: 10px solid #f0f0f0;">
			<div class="content">
			
			</div>
		</div> -->
		<router-view v-slot="{ Component }">
			<transition name="move" mode="out-in">
				<keep-alive :include="tagsList"><component :is="Component" /></keep-alive>
			</transition>
		</router-view>
	</div>
</template>
<script>
export default {
	computed: {
		tagsList() {
			return this.$store.state.tagsList.map(item => item.name);
		},
		collapse() {
			return this.$store.state.collapse;
		}
	}
};
</script>
